import script from "./AnimatedButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedButton.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedButton.vue?vue&type=style&index=0&id=474a75e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474a75e8"]])

export default __exports__